import {
  pageTypes,
  assetExtensionsFromServer,
  loadingScreenValues,
  getNameFromStatusString,
  routeURL,
  UploadTypes,
  ButtonLabel,
  allowedFileTypes,
} from "../constants/commons";
import { downloadAttachments } from "../API/downloadAPI";
import {
  FieldRenderState,
  addressKeyTypes,
  addressType,
  ISelectOption,
  PhoneNumberWithCountryCodeType,
  RegisterationFields,
  StepType,
  oust_status,
  Profession,
} from "../commons/interfaces";
import * as _ from "lodash";
import { Status } from "../atoms/DisplayInfo/interface";
import errorRedLogo from "../assets/error-red-cross-logo.svg";
import successLogo from "../assets/success-icon.svg";
import inProgressLogo from "../assets/in-progress.svg";
import pendingLogo from "../assets/pending-logo.svg";
import warningLogo from "../assets/warning-red-logo.svg";

export const convertQueryParamsToString = (queryParams: any) => {
  let url = "";
  let count = 0;
  for (const property in queryParams) {
    if (queryParams.hasOwnProperty(property)) {
      count += 1;
      url += `${count <= 1 ? "?" : "&"}${property}=${queryParams[property]}`;
    }
  }
  return url;
};

export const convertQueryStringToObject = (queryParams: string) => {
  if (queryParams) {
    const transformedObject: any = {};
    const firstSplit = queryParams.split("?");
    const firstObjects = firstSplit.length > 1 ? firstSplit[1].split("&") : [];
    firstObjects.forEach((obj: any) => {
      const keyValuePair = obj.split("=");
      if (keyValuePair[1] !== "undefined") {
        transformedObject[keyValuePair[0]] = keyValuePair[1];
      }
    });
    return transformedObject;
  } else {
    return {};
  }
};

export const getPageInfo = (location: any, defaultPageSize = 25) => {
  const queryParams = convertQueryStringToObject(location.pathname);
  const currentPage = queryParams.page ? parseInt(queryParams.page) : 1;
  const offset = currentPage - 1;
  const pageSize = queryParams.pageSize
    ? parseInt(queryParams.pageSize)
    : defaultPageSize;
  return { queryParams, currentPage, offset, pageSize };
};

export const isPartnerCentricPage = (page: string) => {
  return page === pageTypes.partnerCentricPage;
};

export const browserDownload = (
  items: any,
  fileTitle: string,
  fileFormat: string
) => {
  let exportedFileName: string = "";
  let blob;
  let link = document.createElement("a");
  switch (fileFormat) {
    case assetExtensionsFromServer.pdf:
      exportedFileName = fileTitle || "export";

      blob = "data:application/pdf;base64," + items;
      link.setAttribute("href", blob);
      break;

    default:
      break;
  }
  link.setAttribute("download", exportedFileName);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const PDFZIPDownloader = async (
  api: string,
  // TODO: Change the type here
  body?: any
) => {
  // TODO: Change the type here
  const attachmentContent: any = await downloadAttachments(api, body, "");

  const { name, data, type } = attachmentContent;

  if (attachmentContent) {
    browserDownload(data, name, type);
  }
};

export const getArrayOFStringFromObjArray = (objArray: any) => {
  return (
    objArray &&
    Object.keys(objArray).length > 0 &&
    objArray.map((data: ISelectOption) => {
      return data.value;
    })
  );
};

export const convertStringArraytoObjectArray = (stringArray: any) => {
  return (
    stringArray &&
    stringArray.map((data: string, key: number) => {
      return { label: data, value: data };
    })
  );
};

export const displayConfirmationWhenWindowCloses = () => {
  window.addEventListener("beforeunload", function (e) {
    e.preventDefault();
    e.returnValue = "";
  });

  window.onbeforeunload = function () {
    return "Do you really want to close?";
  };
};

export const renderImageAsPerStatus = (status: Status) => {
  switch (status) {
    case Status.success:
      return successLogo;
    case Status.error:
      return errorRedLogo;
    case Status.inProgress:
      return inProgressLogo;
    case Status.warning:
      return warningLogo;
    case Status.pending:
      return pendingLogo;
    default:
      return;
  }
};

export const useDataFromServerToDropdwon = (apiData?: string[]) => {
  return apiData && Object.keys(apiData).length > 0
    ? _.orderBy(
        apiData,
        [(data) => (data ? data.toLowerCase() : "")],
        ["asc"]
      ).map((data: string, key: number) => {
        return { label: data, value: data };
      })
    : [];
};

export const availableUploadType = (profession: Profession) => {
  switch (profession) {
    case Profession.YOGA_TRAINER:
      return [
        allowedFileTypes.videoFormat,
        allowedFileTypes.jpeg,
        allowedFileTypes.jpg,
        allowedFileTypes.pdf,
        allowedFileTypes.png,
      ];

    case Profession.FITNESS_TRAINER:
      return [
        allowedFileTypes.videoFormat,
        allowedFileTypes.jpeg,
        allowedFileTypes.jpg,
        allowedFileTypes.pdf,
        allowedFileTypes.png,
      ];

    default:
      return [allowedFileTypes.videoFormat];
  }
};

export const getDownloadableAssetFormat = (imageFormat: string) => {
  switch (imageFormat) {
    case assetExtensionsFromServer.png:
      return `data:image/${assetExtensionsFromServer.png};base64,`;

    case assetExtensionsFromServer.jpg:
      return `data:image/${assetExtensionsFromServer.jpg};base64,`;

    case assetExtensionsFromServer.jpeg:
      return `data:image/${assetExtensionsFromServer.jpeg};base64,`;

    default:
      break;
  }
};

export const getImgURLFromBufferData = (documentsFromServer: any[]) => {
  return (
    documentsFromServer &&
    Object.keys(documentsFromServer).length > 0 &&
    documentsFromServer.map((document: any) => {
      return {
        ...document,
        thumbUrl: `${
          document && document.fileType
            ? getDownloadableAssetFormat(document.fileType)
            : ""
        }${document && document.data ? document.data : ""}`,
      };
    })
  );
};

export const letterCount = (letter: string) => {
  return letter ? letter.length + "/ 300" : 0;
};

export const showDisplayHeadingAndContentFromLoadingStatus = (
  apiLoadingValues: any
) => {
  const { preLoginScreen, postLoginScreen } = apiLoadingValues;
  if (preLoginScreen) {
    return {
      loadingHeading: loadingScreenValues.onPageloadHeadingText,
      loadingDescription: loadingScreenValues.onPageloadBodyText,
    };
  }
  if (postLoginScreen) {
    return {
      loadingHeading: loadingScreenValues.onSavingHeadingText,
      loadingDescription: loadingScreenValues.onSavingBodyText,
    };
  }
  return {
    loadingHeading: loadingScreenValues.onDefaultHeadingText,
    loadingDescription: loadingScreenValues.ondeafultBodyText,
  };
};

export const getStatusComponentDisplayNames = (statusAPI: any) => {
  return (
    statusAPI &&
    statusAPI
      .filter((data: any) => data.type !== StepType.DASHBOARD)
      .map((data: any) => {
        return {
          title: getNameFromStatusString(data.step),
        };
      })
  );
};

export const triggerUserLogin = (erpToken?: string) => {
  let callbackPath = window.location.pathname;
  let hashUrl = window.location.hash;
  callbackPath = `${window.location.pathname}${hashUrl}`;
  if (
    callbackPath === "/#/" ||
    callbackPath.includes(routeURL.partnerPage(""))
  ) {
    callbackPath = `/#/dashboard`;
  }
  callbackPath = encodeURIComponent(callbackPath);

  console.log(`redirect route`);
  erpToken
    ? console.log(
        `/login?next=${callbackPath}&erpToken=${encodeURIComponent(erpToken)}`
      )
    : console.log(`/login?next=${callbackPath}`);

  window.location.href = erpToken
    ? `/login?next=${callbackPath}&erpToken=${encodeURIComponent(erpToken)}`
    : `/login?next=${callbackPath}`;
};

export const getRequestedScreenIndex = (
  currentPage: number,
  statusAPI: any,
  requestedCurrentPageFromStatusComponent: number
) => {
  return (
    currentPage &&
    statusAPI
      .map((data: any) => {
        return data.step;
      })
      .indexOf(
        statusAPI
          .filter((data: any) => data.type !== StepType.DASHBOARD)
          .map((data: any) => {
            return data.step;
          })[requestedCurrentPageFromStatusComponent]
      )
  );
};

export const allowScreenNavigationFromStatusComponent = (
  requestedScreen: number,
  currentScreen: number
): boolean => {
  return requestedScreen <= currentScreen ? true : false;
};

export const getCurrentPageForStatusComponent = (
  dataFromAPI: any,
  currentPage: number
): number => {
  return (
    dataFromAPI &&
    currentPage &&
    dataFromAPI
      .filter((data: any) => data.type !== StepType.DASHBOARD)
      .map((data: any) => {
        return data.step;
      })
      .indexOf(
        dataFromAPI.map((data: any) => {
          return data.step;
        })[currentPage]
      )
  );
};

export const getPhoneNumberAndCountryCodeFromCookie = (
  phoneNumber: string
): PhoneNumberWithCountryCodeType | "" | false => {
  return (
    phoneNumber &&
    phoneNumber.length > 0 && {
      countryCode: phoneNumber.split("-")[0],
      phoneNumber: phoneNumber.split("-")[1],
    }
  );
};

export const testNetworkSpeed = (result: (speedMbps: number) => void) => {
  const imgAdr =
    "https://upload.wikimedia.org/wikipedia/commons/2/2d/Snake_River_%285mb%29.jpg";
  const downloadSize = 4995374; //bytes
  let startTime: any, endTime: any;
  let download = new Image();
  download.onload = function () {
    endTime = new Date().getTime();
    showResults();
  };

  download.onerror = function (err, msg) {
    console.log("Invalid image, or error downloading");
    result(0);
  };

  startTime = new Date().getTime();
  let cacheBuster = "?nnn=" + startTime;
  download.src = imgAdr + cacheBuster;

  function showResults() {
    let duration = (endTime - startTime) / 1000;
    let bitsLoaded = downloadSize * 8;
    let speedBps = parseFloat((bitsLoaded / duration).toFixed(2));
    let speedKbps = parseFloat((speedBps / 1024).toFixed(2));
    let speedMbps = parseFloat((speedKbps / 1024).toFixed(2));
    result(speedMbps);
    console.log(
      "Your connection speed is:",
      speedBps + " bps",
      speedKbps + " kbps",
      speedMbps + " Mbps"
    );
  }
};

export const isFieldOptional = (fieldStatus: FieldRenderState): boolean => {
  switch (fieldStatus) {
    case FieldRenderState.OPTIONAL:
      return true;

    default:
      return false;
  }
};

export const getFieldConfigStatus = (
  professionSpefFields: any,
  fieldSpecificObj: RegisterationFields
) => {
  return (
    professionSpefFields &&
    _.keys(professionSpefFields).length > 0 &&
    professionSpefFields
      .map((field: any) => {
        return field.fieldId === fieldSpecificObj && field.status;
      })
      .filter((data: any) => data !== false)
  );
};

export const getYearsFromMonths = (month: string): number => {
  return Math.round((parseInt(month) / 12 + Number.EPSILON) * 100) / 100;
};

export const getSpecifObjTypeFromAPI = (
  objectArrayfromAPI: addressType[],
  objectType: addressKeyTypes
) => {
  // condition when retrieving country
  if (objectType === addressKeyTypes.COUNTRY) {
    return (
      objectArrayfromAPI &&
      Object.keys(objectArrayfromAPI).length > 0 &&
      _.uniqBy(objectArrayfromAPI, `${objectType}`).map((data) => {
        return data[objectType];
      })
    );
  }
  // condition when retrieving state, city
  return (
    objectArrayfromAPI &&
    Object.keys(objectArrayfromAPI).length > 0 &&
    _.map(objectArrayfromAPI, (data) => {
      return data[objectType];
    }).filter((item, index, inputArray) => {
      return inputArray.indexOf(item) === index;
    })
  );
};

export const getStateCountryObject = (
  city: string,
  objArrayFromAPI: addressType[]
) => {
  return {
    country:
      getStateCountry(city, objArrayFromAPI) &&
      _.keys(getStateCountry(city, objArrayFromAPI)).length > 0 &&
      getStateCountry(city, objArrayFromAPI)[0].country,
    state:
      getStateCountry(city, objArrayFromAPI) &&
      _.keys(getStateCountry(city, objArrayFromAPI)).length > 0 &&
      getStateCountry(city, objArrayFromAPI)[0].state,
  };
};

export const getStateCountry = (
  city: string,
  objArrayFromAPI: addressType[]
): any => {
  return (
    city &&
    city.length > 0 &&
    objArrayFromAPI &&
    Object.keys(objArrayFromAPI).length > 0 &&
    _.map(objArrayFromAPI, (data) => {
      if (data.city === city) {
        return {
          state: data.state,
          country: data.country,
        };
      }
    }).filter((data: any) => {
      return data !== undefined;
    })
  );
};

export const checkIfUploadIsPresentOfType = (
  uploadType: UploadTypes,
  allUploads: any
) => {
  return (
    allUploads &&
    _.keys(allUploads).length > 0 &&
    allUploads
      .map((upload: any) => {
        return upload.uploadType === uploadType;
      })
      .filter((data: any) => data !== false)
  );
};

export const getButtonLabel = (status: any): string => {
  switch (status) {
    case oust_status.PENDING:
      return ButtonLabel.START_MODULE;

    case oust_status.STARTED:
      return ButtonLabel.CONTINUE;

    default:
      return ButtonLabel.START_MODULE;
  }
};

export const getErrorForField = (
  field: RegisterationFields,
  errorObj: any
): string => {
  return errorObj && _.keys(errorObj).length > 0 && errorObj[field];
};
